import { render, staticRenderFns } from "./suspectUser.vue?vue&type=template&id=19435083"
import script from "./suspectUser.vue?vue&type=script&lang=js"
export * from "./suspectUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19435083')) {
      api.createRecord('19435083', component.options)
    } else {
      api.reload('19435083', component.options)
    }
    module.hot.accept("./suspectUser.vue?vue&type=template&id=19435083", function () {
      api.rerender('19435083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/suspectUser.vue"
export default component.exports